"use client";
import { useAuth, UserProfile } from "@clerk/nextjs";
import { dark } from "@clerk/ui/themes";
import { ArrowRightIcon } from "lucide-react";
import { useTheme } from "next-themes";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { SignIn, SignedIn, SignedOut, SignOutButton } from "@/lib/auth/client";

export default function Page() {
  const path = (process.env.NEXT_PUBLIC_BASE_PATH ?? "") + "/sign-in";
  const router = useRouter();
  const { isLoaded, isSignedIn } = useAuth();
  const { theme } = useTheme();
  useEffect(() => {
    if (isLoaded && isSignedIn) {
      router.push("/");
    }
  }, [isLoaded, isSignedIn, router]);
  return (
    <div className="h-screen w-screen flex flex-col items-center justify-center">
      <div className="flex flex-col items-center justify-center size-96 gap-10">
        <SignedOut>
          <SignIn
            path={path}
            appearance={{ theme: theme === "dark" ? dark : undefined }}
          />
        </SignedOut>
        <SignedIn>
          <UserProfile
            path={path}
            appearance={{ theme: theme === "dark" ? dark : undefined }}
          />
          <div className="flex gap-2 items-center">
            <SignOutButton variant="secondary" />
            <Separator orientation="vertical" className="h-6" />
            <Button asChild>
              <Link href="/">
                Go to dashboard <ArrowRightIcon />
              </Link>
            </Button>
          </div>
        </SignedIn>
      </div>
    </div>
  );
}
